export default __webpack_public_path__ + "static/2256-ee20ef30b1aa0b441e3b862030eca849.gif";